"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
export const addFilterValue = (filters, key, value) => {
  const newFilters = __spreadValues({}, filters);
  switch (key) {
    case "job_titles":
      newFilters.job_titles = [...newFilters.job_titles || [], value];
      break;
    case "industries":
      newFilters.industries = [...newFilters.industries || [], value];
      break;
    case "skills":
      newFilters.skills = [...newFilters.skills || [], [value]];
      break;
    case "location":
      newFilters.location = value;
      break;
    case "years_of_experience":
      newFilters.years_of_experience = parseInt(value);
      break;
  }
  return newFilters;
};
export const removeFilterValue = (filters, key, index, subIndex) => {
  var _a, _b, _c;
  const newFilters = __spreadValues({}, filters);
  switch (key) {
    case "job_titles":
      if (index !== void 0) {
        newFilters.job_titles = (_a = newFilters.job_titles) == null ? void 0 : _a.filter((_, i) => i !== index);
      }
      break;
    case "industries":
      if (index !== void 0) {
        newFilters.industries = (_b = newFilters.industries) == null ? void 0 : _b.filter((_, i) => i !== index);
      }
      break;
    case "skills":
      if (index !== void 0 && subIndex !== void 0) {
        newFilters.skills = (_c = newFilters.skills) == null ? void 0 : _c.map((group, i) => i === index ? group.filter((_, j) => j !== subIndex) : group).filter((group) => group.length > 0);
      }
      break;
    case "location":
      delete newFilters.location;
      break;
    case "years_of_experience":
      delete newFilters.years_of_experience;
      break;
  }
  return newFilters;
};
